export default {"src":"/_next/static/media/1care.6e051347.svg","height":39,"width":38,"blurWidth":0,"blurHeight":0};